import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner, Flex, Text } from '@chakra-ui/react';

/**
 * کامپوننت محافظت شده برای مسیرهایی که نیاز به احراز هویت دارند
 * @param {Object} props - props کامپوننت
 * @param {React.ReactNode} props.children - محتوای کامپوننت
 * @param {Array} props.allowedRoles - نقش‌های مجاز (اختیاری)
 * @param {string} props.redirectTo - مسیر هدایت در صورت عدم دسترسی
 */
const ProtectedRoute = ({ 
  children, 
  allowedRoles = [], 
  redirectTo = '/auth/signin' 
}) => {
  const { isAuthenticated, loading, user, hasAnyRole } = useAuth();
  const location = useLocation();

  // اگر در حال بارگذاری است
  if (loading) {
    return (
      <Flex 
        direction="column" 
        pt={{ base: "120px", md: "75px" }} 
        dir="rtl"
        justify="center" 
        align="center" 
        minH="100vh"
      >
        <Spinner size="xl" color="teal.500" />
        <Text mt={4} fontSize="lg" color="gray.600">
          در حال بررسی احراز هویت...
        </Text>
      </Flex>
    );
  }

  // اگر احراز هویت نشده است
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // اگر نقش‌های مجاز تعریف شده‌اند و کاربر دسترسی ندارد
  if (allowedRoles.length > 0 && !hasAnyRole(allowedRoles)) {
    return <Navigate to="/auth/signin" replace />;
  }

  // نمایش محتوای اصلی
  return children;
};

export default ProtectedRoute; 